import React from 'react'
import { connect } from 'react-redux';
import { numberAddCommas } from 'servos/formValidations'
import Option from './Option'
import { getRepaymentWaysTypeOptions } from "../../../../reducers"

class Credit extends React.Component {

  render() {
    const { title, commitment, repaymentWays } = this.props

    return (
      <div>
        <div className='big'>
          {title}
        </div>

        <Option label='Outstanding balance: '>
          {'$'+numberAddCommas(commitment.balance)}
        </Option>

        <Option label='Credit limit: '>
          {'$'+numberAddCommas(commitment.creditLimit)}
        </Option>

        { commitment.repaymentWay &&
          <Option label='Typical way of repayment: '>
            {repaymentWays[commitment.repaymentWay]}
          </Option>
        }

        <Option label='Provider: '>
          {commitment.provider}
        </Option>
        { commitment.owner &&
          <Option label='Owner: '>
            {commitment.owner}
          </Option>
        }
        <hr/>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  repaymentWays: getRepaymentWaysTypeOptions(state),
})

export default connect(mapStateToProps, {})(Credit)
